export default {
  mounted() {
    this.disablePaste();
  },
  methods: {
    disablePaste() {
      if(typeof this.$el.getElementsByTagName === 'function'){
        const inputs = this.$el.getElementsByTagName('input');
        for (let i = 0; i < inputs.length; i++) {
          inputs[i].addEventListener('paste', (event) => {
            event.preventDefault();
            console.log('Pasting is disabled in this field.');
          });
        }
      }
    }
  }
};
